import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  actionWrapper: (getGridsWidth: (width: number) => number) => ({
    width: `${getGridsWidth(2)}px`,
    height: '88px',
    padding: '24px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    border: '1px solid rgba(30, 30, 30, 0.10)',
    boxShadow: '0 0 15px 0 rgba(0, 0, 0, 0.10)',
    backgroundColor: '#fff',
    gap: '12px',
    '&:hover': {
      border: '1px solid rgba(108, 89, 230, 0.50)',
      background: 'rgba(108, 89, 230, 0.05)',
      cursor: 'pointer',
      '& .actionChevron': {
        height: '16px',
        width: '8px',
      },
    },
  }),
  actionIcon: {
    minWidth: '44px',
    minHeight: '44px',
  },
  actionNameWrapper: {
    display: 'flex',
    gap: '20px',
  },
  actionNameText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  actionBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 'auto',
    minWidth: '8px',
  },
  actionNameTextItem: {},
  actionName: {
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '20px',
  },
  actionDescription: {
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '12px',
    opacity: '.7',
  },
}));
